import React from "react";
import {
  class10_soln,
  class11_soln,
  class12_soln,
  class9_soln,
  class_names,
} from "../data/links";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReadMore from "../components/ReadMore";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import "../styles/home.css";

function Home() {
  return (
    <div className="home">
      <Helmet>
        <title>
          NCERT Solutions | NCERT Books| RD Sharma Solutions | NCERT Exemplar
          Problems | CBSE Sample Papers
        </title>
      </Helmet>

      <div className="container">
        <div className="section center">
          <h1>
            NCERT Solutions for Class 9 to 12. <br /> Free CBSE NCERT Solutions
          </h1>
          <ReadMore>
            NCERT Solutions The candidates who are studying under CBSE board and
            in search for NCERT Solutions can refer to this article to this
            article. In this article, we have listed down the NCERT Solutions
            for Class 1 to Class 12 for all the subjects updated for new
            academic session 2022-23 in PDF format. The NCERT Solutions for
            class 1 to class 12 has been written in order to help the students
            in all the level of grades. LearnCBSE has given detailed solutions
            for all the questions keeping the marking scheme for each question.
            This in turn, helps you ace the exam with colourful grades. These
            NCERT Solutions PDF will not only help students to score good marks
            in their class tests, board exams but also helps to clear the
            toughest competitive exams like NEET, JEE Main, JEE Advanced, AIIMS
            etc., Read on to find out everything about NCERT Solutions for all
            the classes here. About NCERT: The National Council of Educational
            Research and Training, http://ncert.nic.in/ is an autonomous
            organization which works under the government of India for the
            improvement of school education. CBSE board and some state boards
            schools such as UP Board, MP Board, Gujarat Board, Bihar,
            Uttarakhand and many other state boards schools follow the
            curriculum & textbooks prescribed by NCERT.
          </ReadMore>
          <div>
            <Link to="/all-solutions">
              {" "}
              <button className="primary-button">View all Soultions</button>
            </Link>
          </div>
        </div>
        <div className="section">
          <h3>NCERT Solutions For Class 1 to Class 12</h3>
          <p>
            The NCERT Solutions for Class 1 to Class 12 which are provided in
            this article are for free of cost. The main objective of this
            article is to help students to provide a strong foundation over all
            the subjects which are covered under their curriculum.
          </p>
          <div className="link-container">
            {class_names.map((solution) => (
              <Link to={solution.title.replace(/\s+/g, "-").toLowerCase()}>
                <button className="border-button">{solution.title}</button>
              </Link>
            ))}
          </div>
        </div>
        <div className="section">
          <h3>NCERT Solutions for Class 12</h3>
          <p>
            NCERT Solutions for all the subjects in Class 12 can be found from
            the following table. Working on Class 12 NCERT solutions is really
            important as the class 12 syllabus is more or less the same as the
            competitive exam syllabus such as JEE, NEET etc., So students who
            have strong command over class 12 NCERT Solutions can easily crack
            the competitive exams without any difficulty. Just click on the link
            in following NCERT Class 12 Solutions table and practice away the
            questions which you want to.
          </p>
          <div className="link-container">
            {class12_soln.map((solution) => (
              <Link to={solution.link}>
                <button className="border-button">{solution.title}</button>
              </Link>
            ))}
          </div>
        </div>
        <div className="section">
          <h3>NCERT Solutions for Class 11</h3>
          <p>
            From the following table, students can find NCERT Solutions for
            class 11 Maths, Physics, Chemistry, English Commerce, Business
            Studies, Computer Science etc., Solving NCERT Solutions for class 11
            will help you to solve the NCERT Class 12 questions. NCERT Solutions
            for class 11 is provided by the best teachers in order to help
            students of class 11 to ace the class 11 exam with decent grades.
            Class 11 NCERT solutions will not only help students to secure a
            good score in class 11 board exams but also helps to crack the
            engineering and medical competitive entrance exams.{" "}
          </p>
          <div className="link-container">
            {class11_soln.map((solution) => (
              <Link to={solution.link}>
                <button className="border-button">{solution.title}</button>
              </Link>
            ))}
          </div>
        </div>
        <div className="section">
          <h3>NCERT Solutions for Class 10</h3>
          <p>
            Candidates who are preparing for the Class 10 board examination must
            be aware of NCERT Solutions for Class 10. Class 10 plays a major
            role in choosing the career stream in the higher secondary level. So
            students who want to shine in grade 10 must score high in Class 10.
            For that having the detailed knowledge of the NCERT Solutions Class
            10 is a must. From the following table, students can find NCERT
            solutions for Class 10. With the help of class 10 NCERT solutions
            students will not only make a good grade in class 10 but will be
            also able to crack the competitive exams without any difficulty.
            Just click on the links in the following table to master the Class
            10 Maths, Science (Physics, Chemistry, Biology), English English
            Literature Reader, First Flight, Footprints Without Feet, and
            English Main Course Book (MCB), Hindi (Sanchayan, Sparsh, Kshitiz,
            Kritika), Social Science (Economics – Understanding Economic
            Development, History – India and the Contemporary World – II,
            Geography – Contemporary India – II, Civics (Political Science) –
            Democratic Politics, Disaster management), Sanskrit and Foundation
            of Information Technology available in FREE PDF format.
          </p>{" "}
          <div className="link-container">
            {class10_soln.map((solution) => (
              <Link to={solution.link}>
                <button className="border-button">{solution.title}</button>
              </Link>
            ))}
          </div>
        </div>
        <div className="section">
          <h3>NCERT Solutions for Class 9</h3>
          <p>
            From the following table students can find out the NCERT Solutions
            for Class 9 Science, Hindi, Maths and English. Students who are
            preparing for the exams like Olympiad, NTSE must have a strong
            foundation over the NCERT Solutions for Class 9. As most of the
            questions in these exams are derived from the NCERT curriculum so in
            order to crack these exams students must have a strong command over
            NCERT Solutions for Class 9. Those students who are in search of
            NCERT Solutions for class 9 Maths, Science (Physics, Chemistry,
            Biology), English English Literature Reader, Moments, Beehive,
            English Workbook and English Main Course Book (MCB), Hindi
            (Sanchayan, Sparsh, Kshitiz, Kritika), Social Science (Economics ,
            History – India and the Contemporary World – I, Geography –
            Contemporary India – I, Civics (Political Science) – Democratic
            Politics ), Sanskrit and Foundation of Information Technology can
            find out from the following table.
          </p>{" "}
          <div className="link-container">
            {class9_soln.map((solution) => (
              <Link to={solution.link}>
                <button className="border-button">{solution.title}</button>
              </Link>
            ))}
          </div>
        </div>
        <div className="section">
          <h1>FAQ</h1>
          <Accordion transition transitionTimeout={250} className="bg-white">
            <AccordionItem header="Where to download NCERT Solutions for all classes and Subjects?">
              The NCERT Solutions for all classes and subjects can be viewed
              online as well as downloaded from LearnCBSE.in. The detailed
              answers for the questions present in the NCERT textbook are solved
              by subject experts at LearnCBSE.in.
            </AccordionItem>

            <AccordionItem header="Difference between NCERT and CBSE?">
              CBSE or Central Board of Secondary Education is a board which is
              the governing body while NCERT or National Council of Educational
              Research and Training is the counsel. NCERT is also known as the
              publishing body or publisher. CBSE schools in India recommends the
              NCERT textbooks to the students. In short, CBSE is a board whereas
              NCERT is a council.
            </AccordionItem>

            <AccordionItem header="What is NCERT and its functions?">
              The full form of NCERT is National Council of Educational Research
              and Training. It is an autonomous organisation set up in 1961 by
              the Government of India, aiming to assist and advise the Central
              as well as the State Governments on policies and programmes for
              qualitative improvement in school education. A few, but major,
              goal of NCERT are as follows:
              <ul>
                <li>
                  To gear up, encourage and correlate research in areas
                  connected with school education
                </li>
                <li>
                  To gear up, encourage and correlate research in areas
                  connected with school education
                </li>
                <li>
                  To organise pre-service and in-service training of teachers
                  along with developing and distributing innovative educational
                  techniques and practices
                </li>
              </ul>
              The function of NCERT is to conduct and support educational
              research and to offer training in educational research
              methodology.
            </AccordionItem>
            <AccordionItem header="Is NCERT is the best resource for board exam ?">
              It is a widely known fact that NCERT books are the best for CBSE
              board exam preparation. But then again, simply byhearting the
              NCERT books a few weeks before the exams is not going to help the
              students with anything. Students should be thorough with the NCERT
              books well ahead of the board exam, giving them ample time to
              practice more questions from other reference books like RS
              Aggarwal, RD Sharma etc. Once done with studying and practicing
              with the books, students should solve the sample papers as well as
              previous year question papers to get an idea of the question paper
              pattern.
            </AccordionItem>
            <AccordionItem header="What is NCERT Exemplar and where can we get it’s Solutions?">
              NCERT Exemplars are basically practice-books that contain
              additional questions of a higher level, apart from NCERT
              textbooks, and are meant for providing comprehensive and thorough
              learning. The NCERT exemplar books accommodate numerous conceptual
              sums, which cover not only CBSE board exams, but also the
              competitive exams like JEE Mains and JEE advanced. The solutions
              for the questions or problems present in the NCERT Exemplar can be
              viewed online or downloaded from LearnCBSE.in.
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </div>
  );
}

export default Home;
